module.exports = __webpack_public_path__ + "static/media/zone_graphic.9a9aecc4.png";